<div id="full-width1" class="dialog widget widget-content corner-all front dialog-buttons draggable popup"
[style.width]="(language == 'HU'|| language == 'ES') ? '590px' : (language == 'SV' ? '535px' : (language == 'RU' ? '533px' : '500px'))">
    <div class="modal-header">
        <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" style="color: white;">{{'Customer Consent'|translate}}
        </div>
        <i class="fa fa-times fa-lg mng-qualifier-close-btn" (click)="activeModal.close('close')" title="close"
            style="cursor:pointer"></i>
    </div>

    <div style="width:auto;min-height :25px;padding: .5em 1em .5em .4em; ">
        <div style="font-size: small;">
            {{'Customer Consent Text'|translate}}
        </div>
    </div>
    <div style="border-top: 1px solid #cecfd6;">
        <div style="margin-top: 10px;margin-bottom: 10px;">
            <button (click)="activeModal.close('close');" class="btn btn-primary shadow-none"
            [style.margin-left]="test1.length<=16 ? '140px' : (test1.length<=19 ? '95px' : '70px')">
                <span>{{test1}}</span>
            </button>
            <button (click)="activeModal.close('close');openModal1()" class="btn btn-primary shadow-none">
                <span>{{test2}}</span>
            </button>
        </div>
    </div> 
 
</div>